import ProgressBar from '../../images/progress.svg';

export const columnDefs = [
  {
    headerName: 'Epic Id',
    field: 'epicId',
    pinned: 'left',
  },
  {
    headerName: 'Summary',
    suppressSizeToFit: true,
    resizable: true,
    field: 'summary',
    pinned: 'left',
  },
];

export const EPIC_COLORS = [
  '#E898D7',
  '#B4D6D4',
  '#86E886',
  '#A7D7D3',
  '#C5D4FF',
  '#8AE8E0',
  '#C5B4F8',
  '#FCD2AC',
  '#FECDCD',
  '#DEB5F7',
  '#ADE3FA',
  '#CDCDCD',
];

export const colSpan = (params) => {
  const ColId = `${params.colDef.field}_skill`;
  const name = params.data[ColId];
  if (name) return params.data[name];
  return '';
};

export const getEpicColors = (name) => {
  let hash = 0;
  if (!name) return EPIC_COLORS[0];
  for (let i = 0; i < name.length; i += 1) {
    const char = name.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0;
  }

  return EPIC_COLORS[Math.abs(hash) % EPIC_COLORS.length];
};

export const getCellColorFromSkill = (skill) => {
  switch (skill) {
    case 'productOwner':
      return '#7A7A7A';
    case 'ux':
      return '#285EFF';
    case 'frontend':
      return '#34C434';
    case 'backend':
      return '#00B7C7';
    case 'android':
      return '#4421AF';
    case 'ios':
      return '#094742';
    case 'qa':
      return '#FF2626';
    case 'devops':
      return '#FF7A00';
    case 'productManager':
      return '#AE1E8F';
    case 'dataEngineer':
      return '#5B8F8B';
    case 'hybridMobile':
      return '#2A0044';
    case 'salesforceEngineering':
      return '#26BEFF';
    default:
      return null;
  }
};

export const cellStyle = (params) => {
  const ColId = `${params.colDef.field}_skill`;
  const value = params.data[ColId];

  if (Object.keys(params.data).length === 0) {
    const resStyle = {
      backgroundColor: 'white',
      border: 'none',
      height: '100%',
    };
    if (params.colDef.field) {
      resStyle.borderRight = '0px';
    }
    return resStyle;
  }

  if (params.colDef.field) {
    const res = {};

    res.backgroundColor = getCellColorFromSkill(value);
    res.borderRadius = '2px';

    if (params.data[`${params.colDef.field}_status`] === 'In Progress') {
      res.backgroundImage = `url(${ProgressBar})`;
    }

    return res;
  }
  return 0;
};

export const skillKeyToSkillName = (skillKey) => {
  switch (skillKey) {
    case 'productOwner': {
      return 'Product Owner';
    }
    case 'ux': {
      return 'UX';
    }
    case 'frontend': {
      return 'Front-end';
    }
    case 'backend': {
      return 'Back-end';
    }
    case 'android': {
      return 'Android';
    }
    case 'ios': {
      return 'IOS';
    }
    case 'qa': {
      return 'QA';
    }
    case 'devops': {
      return 'Dev Ops';
    }
    case 'productManager': {
      return 'Product Manager';
    }
    case 'dataEngineer': {
      return 'Data Engineer';
    }
    case 'hybridMobile': {
      return 'Hybrid Mobile';
    }
    case 'salesforceEngineering': {
      return 'Salesforce Engineering';
    }
    default:
      return '';
  }
};
